const DateInput = ({
  label = 'Unknown Label',
  onChange = null,
  value = '',
  placeholder = '',
  inline = false,
  inputProps = {},
}) => {
  return (
    <div
      className={`px-3 py-2 rounded-xl shadow ${
        inline ? 'flex items-center gap-2' : 'space-y-2'
      }`}
    >
      <label className={`text-gray-700 font-semibold ${!inline && 'block'}`}>
        {label}
      </label>
      <input
        type='date'
        className='w-full border-none'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...inputProps}
      />
    </div>
  );
};

export default DateInput;
